import { ChangeDetectionStrategy, Component, EventEmitter, Injector, Input, Output, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ValueAccessor } from '../../value-accessor/value-accessor';

@Component({
    selector: 'sera-input-text-area',
    templateUrl: './sera-input-text-area.component.html',
    styleUrls: ['./sera-input-text-area.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SeraInputTextAreaComponent),
            multi: true
        }
    ],
    standalone: false
})
export class SeraInputTextAreaComponent extends ValueAccessor<string> {
    @Input()
    isDisabled: boolean = false;

    @Input()
    required: boolean = false;

    @Input()
    inputId!: string;

    @Input()
    name!: string;

    @Input()
    cols: string = '30';

    @Input()
    rows: string = '5';

    @Input()
    placeholder: string = '';

    @Input()
    style!: {};

    @Input()
    label: string | undefined;

    @Input()
    inputStyle: string = '';

    @Input()
    readOnly: boolean = false;

    @Output() inputChanged = new EventEmitter<string>();

    constructor(injector: Injector) {
        super(injector);
    }
}
